import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'tills/'

const initialState = {
    tills: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const addNewTill = createAsyncThunk('tills/ant', async (tillData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'addNewTill', tillData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllTills = createAsyncThunk('tills/gat', async (_, thunkAPI) => {
    try {
        const result = await axios.get(API_URL + 'getAllTills')
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const tillsSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {
        reset: (state) => {
            state.tills = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(addNewTill.pending, (state) => {
                state.isLoading = true
            })
            .addCase(addNewTill.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.tills.push(action.payload)
            })
            .addCase(addNewTill.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(getAllTills.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllTills.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.tills = action.payload
            })
            .addCase(getAllTills.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = tillsSlice.actions

export default tillsSlice.reducer